import { Injectable } from '@angular/core';

import { BarErrorHandlerHook, BarErrorHandlerHookArgs } from './bar-error-handler.hook';
// NOTE implemented because of persisting caching issues with aspnet core fallback index.html action
// https://medium.com/@kamrankhatti/angular-lazy-routes-loading-chunk-failed-42b16c22a377
const CHUNK_FAILED_MESSAGE = /Loading chunk [\d]+ failed/;
@Injectable()
export class BarErrorChunkLoadFailedHook implements BarErrorHandlerHook {
    /** Invoked by the error handler. */
    run(args: BarErrorHandlerHookArgs): void {
        if (args.error?.message && CHUNK_FAILED_MESSAGE.test(args.error.message)) {
            args.handled = true;
            console.warn('Chunk failed to load, reloading the page.');
            window.location.reload();
        }
    }
}
